// @flow

import * as React from 'react';
import { Component, Fragment } from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../utils/responsive';
import { InLine } from '../InLine';
import { Text, Heading, SmallTitle, SmallText } from '../Text';
import { Row, Column, VSpacer } from '../Layout';
import { WatchIcon } from '../Icons';
import { IsMediumScreen } from '../Media';

type Props = {
  wealthCustomer?: boolean,
  callUsPhoneNumberText: string,
  callUsCallPrivatBanker: string,
  callUsPanelHeader: string,
  callUsOpeningHours?: React.Node,
  callUsInformation: string,
};

export default class CallUsPanel extends Component<Props> {
  render() {
    const {
      callUsPanelHeader,
      wealthCustomer,
      callUsOpeningHours,
      callUsInformation,
    } = this.props;

    return (
      <PanelRow>
        <PanelLeftColumn>
          <PanelHeading>{callUsPanelHeader}</PanelHeading>
          <VSpacer small={1} />
          {this.renderPhoneNumber()}
          <VSpacer small={2} />
          {wealthCustomer && this.renderWealthContact()}
          {callUsOpeningHours && (
            <InLine>
              <PanelWatchIcon>
                <WatchIcon />
              </PanelWatchIcon>
              <Text>{callUsOpeningHours}</Text>
            </InLine>
          )}
          <VSpacer small={3} />
          <Text>{callUsInformation}</Text>
        </PanelLeftColumn>
      </PanelRow>
    );
  }

  getNumber = () => {
    //Regex runs through entire string and checks each
    //character for either it being one or more digits or a "+" symbol
    var phoneNumberPattern = /\d+|\+/g;
    var phoneNumber = [
      this.props.callUsPhoneNumberText.match(phoneNumberPattern),
    ];
    phoneNumber = phoneNumber.join();
    return phoneNumber.toString();
  };

  renderPhoneNumber = () => (
    <IsMediumScreen>
      {(match) =>
        match ? (
          <PanelSmallTitle>{this.props.callUsPhoneNumberText}</PanelSmallTitle>
        ) : (
          <PanelSmallTitle
            onClick={() => this.callPhoneEvent('tel:' + this.getNumber())}
          >
            {this.props.callUsPhoneNumberText}
          </PanelSmallTitle>
        )
      }
    </IsMediumScreen>
  );

  callPhoneEvent = (phoneNumber: string) => {
    window.location.href = phoneNumber;
  };

  renderWealthContact = () => (
    <Fragment>
      <SmallText>{this.props.callUsCallPrivatBanker}</SmallText>
      <VSpacer small={3} />
    </Fragment>
  );
}

const PanelRow = styled(Row)`
  height: 100%;
  margin: 0;
`;

const PanelLeftColumn = styled(Column)`
  ${breakpoint('medium')`
    padding: 35px 40px;
  `};
`;

const PanelHeading = styled(Heading)`
  font-size: 0.875rem;
  font-family: DanskeTextv2, Verdana, sans-serif;
  line-height: 1.4;
`;

const PanelSmallTitle = styled(SmallTitle)`
  line-height: 1.2;
`;

const PanelWatchIcon = styled.div`
  position: relative;
  left: -5px;
`;
